module.exports = __webpack_public_path__ + "img/gitlab.5fe02f6f.png";